import HttpRequest from '../http-request';

// 관리자 게시판관리에 등록된(use_yn=1) 게시판 목록
const listBoards = async () => {
  const response = await HttpRequest.get('/api/public/board/listBoards.json');

  return response;
};

const listContents = async (moduleNo, pageNumber = 1, pageSize = 10) => {
  const response = await HttpRequest.get('/api/public/board/listContents.json', {
    moduleNo,
    pageNumber,
    pageSize
  });

  return response;
};

const getContentPublicity = async (moduleNo, contentNo) => {
  const response = await HttpRequest.get('/api/public/board/getContentPublicity.json', {
    moduleNo,
    contentNo
  });

  return response;
};

const listComments = async (moduleNo, contentNo) => {
  const response = await HttpRequest.get('/api/public/boardComment/list.json', {
    moduleNo,
    contentNo
  });

  return response;
};

const adminAddComment = async (contentNo, content) => {
  const form = new FormData();
  form.append('contentNo', contentNo);
  form.append('content', content);

  const response = await HttpRequest.post('/api/boardComment/adminAdd.json', {}, {}, form);

  return response;
};

const adminUpdateComment = async (commentNo, content, password = '') => {
  const form = new FormData();
  form.append('commentNo', commentNo);
  form.append('content', content);
  form.append('password', password);

  const response = await HttpRequest.post('/api/boardComment/adminUpdate.json', {}, {}, form);

  return response;
};

const adminDeleteComment = async (commentNo, password = '') => {
  const form = new FormData();
  form.append('commentNo', commentNo);
  form.append('password', password);

  const response = await HttpRequest.post('/api/boardComment/adminDelete.json', {}, {}, form);

  return response;
};

const adminGetContent = async (moduleNo, contentNo) => {
  const response = await HttpRequest.request(
    '/api/board/adminGetContent.json',
    {},
    { moduleNo, contentNo },
    'POST'
  );

  return response;
};

const getContent = async (moduleNo, contentNo, password) => {
  const response = await HttpRequest.request(
    '/api/public/board/getContent.json',
    {},
    {
      moduleNo,
      contentNo,
      password
    },
    'POST'
  );

  return response;
};

const saveContent = async (form) => {
  const response = await HttpRequest.post('/api/public/board/saveContent.json', {}, {}, form);

  return response;
};

const updateContent = async (form) => {
  const response = await HttpRequest.post('/api/public/board/updateContent.json', {}, {}, form);

  return response;
};

const deleteContent = async (moduleNo, contentNo) => {
  const form = new FormData();
  form.append('moduleNo', moduleNo);
  form.append('contentNo', contentNo);

  const response = await HttpRequest.post('/api/public/board/deleteContent.json', {}, {}, form);

  return response;
};

export default {
  listBoards,
  listContents,
  listComments,
  adminGetContent,
  adminAddComment,
  adminUpdateComment,
  adminDeleteComment,
  getContentPublicity,
  getContent,
  saveContent,
  updateContent,
  deleteContent
};
